module.exports = __webpack_public_path__ + "img/empty-state.1fef5f21.png";